<template>
  <section id="form" class="py-5 bg-white">
    <div class="container">
      <h2 class="text-primary mb-5">Request a Quote</h2>

      <div v-show="isSuccess" class="alert alert-success" role="alert">
        You request has been sent successfully!
      </div>
      <div class="row">
        <div class="col-lg-6">
          <UiFormGroup label="Name" :validator="$v.form.name">
            <input
              type="text"
              v-model="form.name"
              class="form-control"
              name="name"
            />
          </UiFormGroup>
        </div>

        <div class="col-lg-6">
          <UiFormGroup label="Phone Number" :validator="$v.form.phone_number">
            <input
              type="text"
              v-model="form.phone_number"
              class="form-control"
              name="phoneNumber"
            />
          </UiFormGroup>
        </div>

        <div class="col-lg-6">
          <UiFormGroup label="Email" :validator="$v.form.email">
            <input
              type="email"
              v-model="form.email"
              class="form-control"
              name="emailAddress"
            />
          </UiFormGroup>
        </div>

        <div class="col-lg-6">
          <UiFormGroup
            label="Where are you located?"
            :validator="$v.form.location"
          >
            <input
              type="text"
              v-model="form.location"
              class="form-control"
              name="location"
            />
          </UiFormGroup>
        </div>

        <div class="col-lg-12">
          <UiFormGroup label="What would you like to know more about?">
            <textarea
              v-model="form.know_more"
              class="form-control"
              name="details"
            ></textarea>
          </UiFormGroup>
        </div>

        <div class="col-12">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              v-model="form.email_me"
              class="custom-control-input"
              id="customCheck1"
            />
            <label class="custom-control-label" for="customCheck1"
              >Email me the results, too</label
            >
          </div>
        </div>

        <div class="ml-auto col-lg-2 mt-3 text-right">
          <button
            class="btn btn-block btn-primary font-weight-bold"
            value="Submit"
            @click="handleSubmit"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

const defaultForm = () => {
  return {
    name: "",
    phone_number: "",
    email: "",
    location: "",
    know_more: "",
    email_me: false
  };
};

export default {
  props: {
    quote: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isSuccess: false,
      form: {
        ...defaultForm()
      }
    };
  },

  validations: {
    form: {
      name: { required },
      email: { required, email },
      phone_number: { required },
      location: { required }
    }
  },

  methods: {
    handleSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;

      axios
        .post("protect-me/", {
          ...this.form,
          ...this.quote
        })
        .then(() => {
          this.form = {
            ...defaultForm()
          };
          this.$v.form.$reset();
          this.isSuccess = true;
        });
    }
  }
};
</script>
